<h5>
  <ion-row class="ion-justify-content-between ion-align-items-center">
    <ion-row class="ion-align-items-center">
      {{ castedFieldName | translate}}
      <ion-badge color="secondary" *ngIf="selectedOptions && selectedOptions.size > 0" class="ion-margin-start">
        {{selectedOptions.size}}
      </ion-badge>
    </ion-row>
    <ion-button fill="outline" size="small" shape="round" (click)="toggleFiltersOpenState()">
      <ion-icon name="chevron-up-outline" [class.rotate]="!filtersOpenState"></ion-icon>
    </ion-button>
  </ion-row>
</h5>
<ion-list class="ion-no-padding" @slideUpDown *ngIf="filtersOpenState">
  <ion-item lines="full" *ngFor="let option of optionsMap | keyvalue" [style.order]="selectedOptions?.has(option.key) ? -1 : 0">
    <ion-label>{{ option.key }} ({{ option.value }})</ion-label>
    <ion-checkbox color="secondary" slot="start" [checked]="selectedOptions?.has(option.key)"
      (ionChange)="onOptionChange($event, option.key)"></ion-checkbox>
  </ion-item>
</ion-list>
